module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAzklEQVQokX3SSQoCMRSE4d9G1JM6C464cFiIjQsHnBbqEfp4Iq4EpSQNMb7u2uUlXwhFCkmSLIAecACmZKcArIEqsCoCY6AETIAyMDKo0BFou3U/Ai7egaG7NQ8pJ8EucMvAFoqBhZ76BupuWPWwUjHQt4eiG+ThP6RE3kaKr0Y5cdh4ZBx6GbNKOPChijgBLQMOgI0Fhc4BWgbP/sEqJ0XNAM3cnlLzsGYDwW0GUlRYI2i9Dzz11E4GSiOki/0fVhPUL3kAcwOFeA/cgd0HZ6YzGF3xYlsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/close.png
// module id = LQWl
// module chunks = 1